import { render, staticRenderFns } from "./BillDetailsSidebar.vue?vue&type=template&id=280aae62"
import script from "./BillDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./BillDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./BillDetailsSidebar.vue?vue&type=style&index=0&id=280aae62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports